export const PAGE_NAMES = {
    main: 'careers_page',
    jobs: 'careers_job_page',
    thankYou: 'careers_thank_you_page',
} as const;

export type PageName = (typeof PAGE_NAMES)[keyof typeof PAGE_NAMES];

export const EVENT_NAMES = {
    sectionShown: 'careers_section_is_shown',
    testimonialShown: 'careers_testimonial_is_shown',
    ctaClick: 'clicked_on_careers_cta',
    positionShown: 'careers_open_position_is_shown',
    positionClick: 'clicked_on_careers_open_position',
    filterClick: 'clicked_on_careers_positions_filter',
    unusualWayStepShown: 'careers_unusual_way_step_is_shown',
    unusualWayStepSubmit: 'clicked_on_careers_unusual_way_step_submit',
    cvUploadStart: 'careers_cv_upload_started',
    cvUploadFailed: 'careers_cv_upload_failed',
    cvUploadSuccess: 'careers_cv_upload_succeeded',
    cvUploadNoMatch: 'careers_cv_upload_no_match',
} as const;

export const SECTION_NAMES = {
    hero: 'hero_section',
    intro: 'intro_section',
    testimonials: 'testimonials_section',
    ourValues: 'our_values_section',
    offices: 'offices_section',
    cvDrop: 'cv_drop_section',
    openPositions: 'open_positions_section',
    unusualWay: 'unusual_way_section',
    jobHero: 'job_hero_section',
    jobDescription: 'job_description_section',
    apply: 'apply_section',
} as const;

export type SectionName = (typeof SECTION_NAMES)[keyof typeof SECTION_NAMES];
